(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/about-freja.js') >= 0) return;  svs.modules.push('/modules/player-login/views/about-freja.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.about_freja = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>\n  Freja är en elektronisk ID-handling som är jämförbar med pass, \n  körkort och andra fysiska legitimationer.\n</p>\n\n<b>Var laddar du ner Freja eID-appen?</b>\n<p>\n  Ladda ner appen gratis från Appstore, Google Play eller AppGallery.\n</p>\n  \n<b>Behöver du hjälp?</b>\n<p>\n  Ring oss på 0770 - 11 11 11\n</p>\n";
},"useData":true});
Handlebars.partials['svs-player_login-about_freja'] = svs.player_login.templates.about_freja;
})(svs, Handlebars);


 })(window);